import Init from '../../../extendable/Init';

import './Register.scss';

const Register = () => {
};

Init(Register);
